var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "loginbg",
      staticStyle: { display: "none" },
      attrs: { id: "login-main-hr" }
    },
    [
      _c("div", { staticClass: "container" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-sm-9 col-md-7 col-lg-5 mx-auto" }, [
            _c("div", { staticClass: "loginform" }, [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "form",
                {
                  attrs: { id: "forgotPassword", name: "form" },
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.emailVerify()
                    }
                  }
                },
                [
                  _c("div", { staticClass: "form-group" }, [
                    _c("label", { attrs: { for: "username" } }, [
                      _vm._v("Email")
                    ]),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.email,
                          expression: "email"
                        }
                      ],
                      staticClass: "form-control",
                      attrs: {
                        type: "text",
                        name: "email",
                        id: "email",
                        placeholder: "Enter Email"
                      },
                      domProps: { value: _vm.email },
                      on: {
                        input: function($event) {
                          if ($event.target.composing) {
                            return
                          }
                          _vm.email = $event.target.value
                        }
                      }
                    }),
                    _vm._v(" "),
                    _c("span", { staticClass: "help is-danger" }, [
                      _vm._v(_vm._s(_vm.emailError))
                    ])
                  ]),
                  _vm._v(" "),
                  _vm._m(1),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          staticStyle: { "margin-top": "3%" },
                          attrs: {
                            disabled: _vm.disableButtons.submitButton,
                            id: "loginbtn",
                            type: "submit"
                          }
                        },
                        [_vm._v(_vm._s(_vm.buttonNames.submitButton))]
                      ),
                      _vm._v(" "),
                      _c(
                        "router-link",
                        {
                          staticClass: "pull-right",
                          staticStyle: {
                            "text-decoration": "underline !important",
                            "margin-top": "6%"
                          },
                          attrs: { to: { name: "CustomerLogin" } }
                        },
                        [_vm._v(" Back to Login")]
                      )
                    ],
                    1
                  )
                ]
              )
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "loginlogo" }, [
      _c("img", {
        attrs: {
          src: "/static/images/login-logo.png",
          alt: "Velocity Vehicle Group"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [_c("label", { attrs: { id: "errorMsg" } })])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ac78c9dc", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac78c9dc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Login/CustomerForgotPassword.vue
// module id = null
// module chunks = 